import { UnstyledButton as MantineUnstyledButton } from "@mantine/core";

import classes from "./UnstyledButton.module.css";

export const UnstyledButton = MantineUnstyledButton.extend({
  classNames: {
    root: classes.root,
  },
});
